// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1780":"f60e99d7344f94337cdc","2949":"6d72d6399f097646362f","3241":"8c5b220bf6f482881a90","5330":"6d72d6399f097646362f","6327":"8c5b220bf6f482881a90"}[chunkId] + ".css";
};